import { defineStore } from 'pinia'
import { useFolderStore } from '../stores/folder.js'
import { ref, watch } from 'vue'
import { FolderPage } from '@/enums/folder-page.js'
import { useSharedFetcher } from '../services/sharedFetcher.js'
import { getOwnBank, getBankSearch } from '@services/digitalBank'

export const useDigitalBankStore = defineStore('digitalBankStore', () => {
  const fetcher = useSharedFetcher()
  const contacts = ref([])
  const filteredContacts = ref([])
  const searchQuery = ref('')
  const page = ref(1)
  const isAdded = ref(false)
  let searchTimer = null
  const isSearch = ref(false)
  const loading = ref(false)
  const count = ref(null)
  const lastLoadPage = ref(0)
  const isForks = ref(false)
  const filter = ref(false)
  const searchQueryFolder = ref('')
  const findedContactFolder = ref([])
  let searchTimerFolder = null
  const folderId = ref('')
  const currentId = ref('')
  const folderContacts = ref(null)

  const folderStore = useFolderStore()

  const getContactsBank = async (
    isFork = isForks.value,
    own,
    take = 24,
    accLevel,
    expirienceLevel,
    language,
    industry,
    direction,
    competence,
    country,
    city
  ) => {
    isAdded.value = own
    loading.value = true
    if (!isFork && contacts.value.length) return contacts.value

    const response = await getOwnBank(fetcher, {
      search_text: searchQuery.value || undefined,
      access_level: accLevel,
      expertise_level: expirienceLevel,
      languages: language,
      industries: industry,
      directions: direction,
      competences: competence,
      countries: country,
      cities: city,
      folderId: folderId.value || undefined,
      take,
      page: page.value
    })

    findedContactFolder.value = response?.data
    if (folderStore.activeStep === FolderPage.AddContactToFolder) {
      findedContactFolder.value = response?.data
    } else {
      const newContacts = response?.data
      count.value = response?.count
      filter.value = response?.filter
      loading.value = false
      if (page.value === 1) {
        contacts.value = newContacts
      } else {
        contacts.value = [...contacts.value, ...newContacts]
      }
      return contacts.value
    }
  }

  const loadNextPage = async () => {
    if (lastLoadPage.value && lastLoadPage.value > 1) {
      page.value = lastLoadPage.value || 1
    }
    page.value += 1
    lastLoadPage.value = page.value

    await getContactsBank(true, isAdded.value, 24)
  }

  const getFilteredContact = async ({ name, lastName, country, city }) => {
    const response = await getBankSearch(fetcher, {
      search_first_name: name || undefined,
      search_last_name: lastName || undefined,
      countries: country,
      cities: city
    })

    filteredContacts.value = response.data
    return filteredContacts.value
  }

  const findDigitalForFolder = async (search) => {
    const response = await getOwnBank(fetcher, {
      search_text: search || undefined,
      take: 24,
      page: 1
    })

    if (response?.data) {
      findedContactFolder.value = response.data
    }
  }
  const getContactsforFolder = async () => {
    const response = await getOwnBank(fetcher, {
      folderId: currentId.value,
      take: 24,
      page: 1
    })
    if (response?.data) {
      folderContacts.value = response.data
    }
  }

  watch(
    searchQuery,
    () => {
      clearTimeout(searchTimer)
      searchTimer = setTimeout(() => {
        page.value = 1
        getContactsBank(true, isAdded.value, 24)
      }, 1000)
    },
    { deep: true }
  )
  watch(
    searchQueryFolder,
    () => {
      clearTimeout(searchTimerFolder)
      searchTimerFolder = setTimeout(() => {
        findDigitalForFolder(searchQueryFolder)
      }, 1000)
    },
    { deep: true }
  )

  return {
    contacts,
    getContactsBank,
    searchQuery,
    loadNextPage,
    page,
    isSearch,
    count,
    filteredContacts,
    getFilteredContact,
    loading,
    lastLoadPage,
    isForks,
    filter,
    searchQueryFolder,
    findDigitalForFolder,
    findedContactFolder,
    folderId,
    currentId,
    getContactsforFolder,
    folderContacts
  }
})
